import ReactDOM from "react-dom";
import { TableWrapper } from "./components/TableWrapper";

(() => {
  const containers = document.querySelectorAll<HTMLElement>(
    "[data-mediawijs-inclusion]"
  );

  const data = document.getElementById("inclusion-data")?.textContent;

  if (!containers || !data) return;

  ReactDOM.render(<TableWrapper rows={JSON.parse(data).rows} />, containers[0]);
})();
